import { defineComponent as _defineComponent } from 'vue'
import InvoiceSection from '@/views/my-projects/components/invoice/InvoiceSection.vue';
import Vue, { computed, ref, watch } from 'vue';
import BCXForm from '@/components/molecules/forms/BCXForm.vue';
import { BcxFormField } from '@/models/BcxForm';
import { watchIgnorable } from '@vueuse/core';
import useInvoice from '@/views/my-projects/composables/useInvoice';
import { cloneDeep } from 'lodash';
import { ComponentInvoiceTextData, PayloadUpdateInvoice } from '@/models/Invoice';
import useUser from '@/mixins/useUser';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoiceTexts',
  setup(__props) {

const {
  componentInvoiceTextData, fetchUpdateInvoice, canInvoiceBeEdited, errorMessages, findChangedProps,
  createDebounceWithCallback, debounceFilterStatus
} = useInvoice();
const localTextData = ref(cloneDeep(componentInvoiceTextData.value));

const { tUserFallback: t } = useUser('self');

const autoSaveTrigger = ref(0);

const fields = computed(() => {
  const fields:BcxFormField[] = [
    {
      name: 'intro',
      width: '100%',
      label: `${t('invoice.texts.form.intro_USERTYPE')}`,
      labelHint: `${t('invoice.texts.form.introLabelHint_USERTYPE')}`,
      type: 'textarea',
      textareaOptions: {
        maxLength: 300,
        height: 100
      },
      disabled: !canInvoiceBeEdited.value,
    },
    {
      name: 'footer',
      width: '100%',
      label: `${t('invoice.texts.form.footer_USERTYPE')}`,
      labelHint: `${t('invoice.texts.form.footerLabelHint_USERTYPE')}`,
      type: 'textarea',
      textareaOptions: {
        maxLength: 300,
        height: 100
      },
      disabled: !canInvoiceBeEdited.value,
    },
  ];
  return fields;
});

// Payload should be updated with the local data
function createPayload(): PayloadUpdateInvoice {
  const textData = localTextData.value;

  return {
    invoiceText: {
      intro: textData.intro,
      footer: textData.footer,
    },
  };
}

const { ignoreUpdates } = watchIgnorable<ComponentInvoiceTextData>(
  localTextData,
  async () => {
    try {
      if (!canInvoiceBeEdited.value) return;
      const payload = createPayload();
      await fetchUpdateInvoice(0, payload);
      ignoreUpdates(() => {
        componentInvoiceTextData.value = localTextData.value;
      });
      autoSaveTrigger.value++;
    } finally {
      debounceFilterStatus.value.texts = false;
    }
  },
  {
    eventFilter: createDebounceWithCallback(1000, () => {
      debounceFilterStatus.value.texts = true;
    })
  }
);

watch(
  () => componentInvoiceTextData.value,
  () => {
    ignoreUpdates(() => {
      localTextData.value = cloneDeep(componentInvoiceTextData.value);
    });
  },
  { immediate: false }
);

watch(
  () => localTextData.value,
  (newValue: ComponentInvoiceTextData, oldValue: ComponentInvoiceTextData) => {
    const changed = findChangedProps(newValue, oldValue);
    const key = changed[0];

    if (changed.length === 1 && errorMessages.value[key]) {
      Vue.delete(errorMessages.value, key);
    }
  }
);

return { __sfc: true,componentInvoiceTextData, fetchUpdateInvoice, canInvoiceBeEdited, errorMessages, findChangedProps, createDebounceWithCallback, debounceFilterStatus, localTextData, t, autoSaveTrigger, fields, createPayload, ignoreUpdates, InvoiceSection, BCXForm }
}

})